import { inject, ref, reactive, onActivated, onDeactivated } from 'vue';
import { useStore } from 'vuex';
import { routerPush } from '@/router';
import { AUTH_LOGIN } from "@/store/actions.type";
export default {
  name: 'Login',

  setup() {
    const store = useStore();
    const logger = inject('logger');
    const componentState = reactive({
      isLoading: false,
      isRendered: false
    });
    onActivated(() => {
      componentState.isRendered = true;
    });
    onDeactivated(() => {
      componentState.isRendered = false;
    });
    const validationRules = {
      login: [{
        required: true,
        message: "Nazwa użytkownika jest wymagana",
        trigger: "blur"
      }],
      password: [{
        required: true,
        message: "Hasło jest wymagane",
        trigger: "blur"
      }]
    };
    const credentialsForm = ref();
    const credentials = reactive({
      login: '',
      password: ''
    });

    function validateCredentials() {
      credentialsForm.value.validate(valid => {
        if (!valid) return;
        loginUser();
      });
    }

    function loginUser() {
      componentState.isLoading = true;
      store.dispatch(AUTH_LOGIN, credentials).then(() => routerPush('home')).catch(error => logger(error)).finally(() => componentState.isLoading = false);
    }

    return {
      componentState,
      validationRules,
      credentialsForm,
      credentials,
      validateCredentials
    };
  }

};